// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__RCHjb","container":"App_container__eSJ6i","content":"App_content__1Wt3K","privateBackground":"App_privateBackground__3xlM_"};